import React from "react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function LoginPage() {
  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/portal';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6 pt-24 pb-12">
      <div className="max-w-md w-full text-center tracing-beam p-12 bg-surface border border-white/5">
        <div className="overline">Client Portal</div>
        <h1 className="font-display font-light text-4xl md:text-5xl mt-6">Welcome back.</h1>
        <p className="text-secondary mt-4 leading-relaxed">Sign in to access your projects, invoices, recordings, and the AI Academy.</p>
        <button onClick={startLogin} className="btn-primary w-full mt-10 justify-center" data-testid="login-google-btn">
          Continue with Google
        </button>
        <p className="text-muted text-xs uppercase tracking-widest mt-8">Powered by Emergent Secure Auth</p>
      </div>
    </main>
  );
}
